
import { defineComponent, ref } from 'vue';
import Axios from '@/core/services/Http';
import { Notify } from '@/core/services';
import { Modal } from 'bootstrap';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import InnerLoader from '@/components/InnerLoader.vue';
import { isErplyProvider } from '@/core/helpers/erpProvider';

export default defineComponent({
    name: 'Warehouses',
    components: {
        InnerLoader
    },
    props: {
        erp_enable: Number,
        sync_products_enable: Number
    },
    setup(props) {
        const store = useStore();
        const route = useRoute();
        const i18n = useI18n();
        const modal: any = ref();
        const reports = ref([]) as Record<any, any>;
        const loading = ref(false);

        const getWarehouses = () => {
            // if (props.erp_enable == 0 || props.sync_products_enable == 0) {
            //     Notify.error(i18n.t('message.SERVICE_NOT_ENABLED'));
            //     return;
            // }
            if (!isErplyProvider(store, route.path)) {
                Notify.error(i18n.t('message.SERVICE_NOT_ENABLED'));
                return;
            }
            store.getters.appInstance.$messageBox
                .confirm(`${i18n.t('message.ARE_YOU_SURE_TO_SYNC_WAREHOUSES')}?`, i18n.t('message.INFO'), {
                    confirmButtonText: i18n.t('message.OK'),
                    cancelButtonText: i18n.t('message.CANCEL'),
                    type: 'info'
                })
                .then(async () => {
                    loading.value = true;
                    try {
                        const response = await Axios.get('/erply/get-warehouses');
                        loading.value = false;
                        if (response.data?.status == 404) {
                            Notify.error(i18n.t('message.WAREHOUSES'));
                            return;
                        }
                        if (response?.data?.report?.length > 0) {
                            reports.value = response.data.report;
                            modal.value = new Modal(document.getElementById('show_report_for_warehouses')) as HTMLElement;
                            modal.value.show();
                        } else {
                            Notify.success(i18n.t('message.WAREHOUSES_SYNC_STARTED'));
                        }
                    } catch ($e) {
                        Notify.error($e);
                        loading.value = false;
                    }
                })
                .catch(() => {
                    loading.value = false;
                });
        };

        return {
            reports,
            loading,
            getWarehouses
        };
    }
});
